import type { ServiceConfigFactory } from '../../types'

export default (({ bootstrapData }) => {
	const { dynamicRouteData } = bootstrapData.platformEnvData.router
	return {
		dynamicRouteData: dynamicRouteData ?? null,
	}
}) as ServiceConfigFactory
